import { useEffect } from "react";
import type { NavigationItemType } from "../navigation/types";
import { useBreadcrumbsStore } from "./breadcrumbs-store";

type NavigationEntry = NavigationItemType | "divider" | string;

/**
 * Publish the paths a navigation links to as the static paths the breadcrumbs may link to. A URL
 * segment such as `stock` or `suborders` has no page of its own, and a crumb pointing at it opens a
 * blank screen — the navigation is the one list of the paths that do have one, already narrowed to
 * what the caller may open.
 *
 * @param navigationItems - The navigation's entries, groups included.
 */
export function useBreadcrumbPagePaths(navigationItems: Array<NavigationEntry>) {
	/** Hooks */
	const setPagePaths = useBreadcrumbsStore((store) => store.setPagePaths);

	/** Effects */
	useEffect(() => {
		setPagePaths(collectNavigationPaths(navigationItems));
	}, [navigationItems]);
}

function collectNavigationPaths(
	navigationItems: Array<NavigationEntry>,
	paths: Set<string> = new Set(),
) {
	for (const item of navigationItems) {
		if (typeof item === "string") continue;
		if (item.to) paths.add(item.to);
		if (item.items) collectNavigationPaths(item.items, paths);
	}
	return paths;
}
